<template>
  <div>
    <v-img
        v-if="possuiFotoEmpresa"
        id="fotoEmpresa"
        :src="createUrl($store.state.configuracao.parametros.fotoEmpresa)"
        class="foto-empresa-toolbar"
        alt="Foto da empresa"
        aspect-ratio="1"
        height="350"
        width="350"
    />
    <v-img
        v-else
        id="fotoEmpresa"
        src="/images/avatares/avatar-padrao.png"
        class="foto-empresa-toolbar"
        alt="Foto da empresa"
        aspect-ratio="1"
        height="350"
        width="350"
    />
  </div>
</template>

<script>
export default {
    name: 'FotoEmpresa',
    computed: {
        possuiFotoEmpresa() {
            return (
                this.$store.state.configuracao.parametros &&
          this.$store.state.configuracao.parametros.fotoEmpresa
            )
        },
    },
}
</script>


<style scoped lang="stylus">

.foto-empresa-toolbar
  border-radius 5px
  box-shadow rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset

</style>